// extracted by mini-css-extract-plugin
export default {"card":"Card-module__card--LILA4","inner-wrapper":"Card-module__inner-wrapper--nKrB_"};